import React, { useState } from 'react'
import * as yup from 'yup';
import { addReRoute } from '../actions';
import swal from 'sweetalert';
import { useMutation, useQueryClient } from 'react-query';
import { Modal } from 'react-bootstrap';
import PhoneInput, { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";



const initialState = {
    phone_number: [{ number: '' }]
};

export const validationSchema = yup.object({
    phone_number: yup.array().of(
        yup.object().shape({
            number: yup.string().required('Phone number field is required')
        })
    ),
});

const AddReRouteModal = ({
    setOpenModal = () => { },
    openModal = false,
}) => {
    const [phoneError, setPhoneError] = useState(null)
    const queryClient = useQueryClient();

    const {
        handleSubmit,
        control,
        formState: { errors },
        watch,
        setValue,
        reset,
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: initialState,
        mode: "all",
        reValidateMode: "onChange",

    });
    const { fields, append, remove } = useFieldArray({
        control,
        name: "phone_number",
    });

    const handleRemove = (index) => {
        if (fields?.length === 1) {
            swal({
                text: "Minimum 1 number is required.",
                icon: "error",
            });
            return false;
        }
        remove(index);
    };

    const handleAdd = () => {
        if (fields?.length > 9) {
            swal({
                text: "Minimum 10 number are valid.",
                icon: "error",
            });
            return false;
        }
        append({
            number: "",
        });
    };

    const handleSubmitForm = async (values) => {
        const { phone_number = [] } = values || {};
        const numbers = phone_number?.map(item => item?.number);
        if (!numbers.length) return swal({
            text: "Please enter a number",
            icon: "error",
        });
        mutate({ phone_number: numbers.map(res => res.replace('+', '')) })
    };


    const handleClose = () => {
        setOpenModal(false);
        setPhoneError(null)
        reset()
    };

    const handleCheckPhoneValidation = (phone, index) => {
        if (phone) {
            if (
                !isPossiblePhoneNumber(phone) ||
                !isValidPhoneNumber(phone)
            ) {
                setPhoneError({ error: true, index });
            } else {
                setPhoneError(null);
            }
        } else {
            setPhoneError(null);
        }
    }

    const { isLoading, mutate } =
        useMutation('addReRoute', addReRoute, {
            onSuccess: (data) => {
                setOpenModal(false);
                setPhoneError(null)
                swal({
                    text: data?.data?.message ?? 'Success!',
                    icon: 'success',
                    type: 'success',
                    timer: 3000,
                }).then(() => {
                    queryClient.invalidateQueries('UserListing');
                    reset();
                });
            },
            onError: (error) => {
                setPhoneError(null)
                swal({
                    type: 'danger',
                    text: error?.response?.data?.message,
                    icon: 'error',
                    timer: 3000,
                });
            },
        });

    return (
        <Modal
            size="md"
            centered
            show={openModal}
            onHide={() => handleClose()}
            backdrop="static"
            keyboard={false}
        >
            <form onSubmit={handleSubmit(handleSubmitForm)}>
                <div className="modal-header ">
                    <div className="icon_arrow"></div>
                    <h5 className="modal-title heading heading--xs mb-0 ">
                        Add Re-Route
                    </h5>
                </div>

                <div className="modal-body">
                    <div className="form-group input_control input_control--gap">
                        {fields?.map((item, index) => {
                            return (
                                <>
                                    <label>Phone Number</label>
                                    <div className="row mb-3 d-flex align-items-start justify-content-between" key={item.id}>
                                        <div className="col-md-8">
                                            <Controller
                                                control={control}
                                                name={`phone_number[${index}].number`}
                                                render={() => (
                                                    <PhoneInput
                                                        defaultCountry={'FR'}
                                                        international={true}
                                                        addInternationalOption={false}
                                                        withCountryCallingCode={true}

                                                        internationalIcon={() => (
                                                            <span>
                                                                <i className="fa fa-phone  icon-circle bg-danger"></i>
                                                            </span>
                                                        )}
                                                        type="text"
                                                        className="form-control"
                                                        value={watch(`phone_number[${index}].number`)}
                                                        onChange={(phone) => {
                                                            handleCheckPhoneValidation(phone, index)
                                                            setValue(
                                                                `phone_number[${index}].number`,
                                                                phone,
                                                                {
                                                                    shouldValidate: true,
                                                                }

                                                            )
                                                        }

                                                        }
                                                        limitMaxLength={13}
                                                    />
                                                )}
                                            />
                                            {(errors?.phone_number?.[index]?.number?.message) ||
                                                phoneError?.error && phoneError?.index === index ? (
                                                <div className="error_required w-100 mb-0">
                                                    {errors?.phone_number?.[index]?.number?.message ||
                                                        `Phone number is not valid`}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className='col-md-4'>
                                            <div className='d-flex align-items-center' style={{
                                                gap: '8px'
                                            }}>
                                                {index > 0 && (
                                                    <button
                                                        className="btn btn-danger"
                                                        href={void 0}
                                                        onClick={() => handleRemove(index)}
                                                        type="button"
                                                        style={{
                                                            minWidth: '40px'
                                                        }}
                                                    >
                                                        -
                                                    </button>
                                                )}
                                                {index < 9 && (
                                                    <button
                                                        className="btn btn-success"
                                                        href={void 0}
                                                        onClick={() => handleAdd(index)}
                                                        type="button"
                                                        style={{
                                                            minWidth: '40px'
                                                        }}
                                                    >
                                                        +
                                                    </button>
                                                )}
                                            </div>
                                        </div>


                                    </div></>
                            );
                        })}

                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleClose()}
                    >
                        Close
                    </button>

                    <button
                        type="submit"
                        disabled={phoneError || isLoading}
                        className="btn btn-dark-blue"
                    >
                        {isLoading
                            ? 'Please Wait...'
                            : 'Submit'}
                    </button>
                </div>
            </form>
        </Modal>
    )
}

export default AddReRouteModal